import React from "react";

/**
 * StepsSection (reusable)
 * -----------------------------------------------
 * Props:
 * - title: string                     // section heading
 * - subtitle?: string                 // section subheading
 * - steps: { img: string, title: string, desc: string }[]
 * - bgColor?: string                  // background color (default: white)
 * - accentColor?: string              // color for connector line (default: #F1652D)
 */
export default function HowItWorks({
  title,
  subtitle = "",
  steps = [],
  bgColor = "white",
  accentColor = "#F1652D",
}) {
  return (
    <section className="py-16 sm:py-20" style={{ backgroundColor: bgColor }}>
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        {/* Heading */}
        <h2 className="text-center text-3xl sm:text-4xl font-extrabold text-slate-800">
          {title}
        </h2>
        {subtitle && (
          <p className="mt-2 text-center text-slate-500">{subtitle}</p>
        )}

        {/* Steps with connector */}
        <div className="relative mt-10 md:mt-12">
          {/* connector line (desktop only) */}
          <div
            className="hidden md:block absolute left-0 right-0 top-[92px] h-[2px]"
            style={{ backgroundColor: accentColor + "33" }} // 20% opacity
          />

          <div className="grid gap-8 md:grid-cols-3">
            {steps.map((s, i) => (
              <div
                key={s.title + i}
                className="relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-6 sm:p-7 shadow-sm"
              >
                <div className="flex flex-col items-center text-center">
                  {/* Step icon */}
                  <div className="z-10">
                    <img
                      src={s.img}
                      alt={s.title}
                      className="object-contain"
                      draggable="false"
                    />
                  </div>

                  {/* Step title */}
                  <h3 className="mt-4 text-lg sm:text-xl font-semibold text-slate-900">
                    {s.title}
                  </h3>

                  {/* Step description */}
                  <p className="mt-2 max-w-[26ch] sm:max-w-[34ch] text-sm text-slate-500">
                    {s.desc}
                  </p>
                </div>

                {/* hide connector line overlap visually */}
                <div className="hidden md:block absolute left-0 right-0 top-[92px] h-[2px] bg-white" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
